const TextIcon = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
        <path d="M2.66992 7.67003V5.85003C2.66992 4.70003 3.59992 3.78003 4.73992 3.78003H19.2599C20.4099 3.78003 21.3299 4.71003 21.3299 5.85003V7.67003" stroke="#0D0D0D" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M12 21.2201V4.61011" stroke="#0D0D0D" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M8.06055 21.22H15.9405" stroke="#0D0D0D" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      </svg>
    );
  };
  
  export default TextIcon;